import React from "react";

import { resolveColor } from "utils/commonFunctions";

interface Props {
    size?: number;
    color?: string;
}

export const History = (props: Props) => {
    return (
        <svg
            width={props.size ?? 24}
            height={props.size ?? 24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.60263 6.01519C6.92413 4.55984 8.9898 3.23169 11.9558 3.25019C16.7846 3.28031 20.7204 7.21653 20.7498 12.0453C20.7794 16.8813 16.8801 20.78 12.0441 20.7498C7.21526 20.7197 3.27949 16.7835 3.25001 11.9547C3.24749 11.5405 3.58122 11.2027 3.99542 11.2001C4.40963 11.1976 4.74746 11.5313 4.74999 11.9455C4.77445 15.9531 8.04579 19.2249 12.0534 19.2499C16.0539 19.2748 19.2743 16.0548 19.2499 12.0545C19.2254 8.0469 15.9541 4.77516 11.9464 4.75016C9.0829 4.7323 7.23604 6.22782 6.19319 7.65843L7.53849 7.66682C7.9527 7.66941 8.28638 8.00728 8.2838 8.42149C8.28122 8.83569 7.94334 9.16938 7.52914 9.16679L4.8625 9.15016C4.4519 9.1476 4.11969 8.81535 4.11719 8.40476L4.10091 5.73815C4.09838 5.32394 4.43211 4.98611 4.84632 4.98358C5.26052 4.98105 5.59835 5.31478 5.60088 5.72899L5.60263 6.01519ZM12.09 6.51973C12.5042 6.5204 12.8395 6.85672 12.8388 7.27093L12.8307 12.3233L15.1523 13.9113C15.4942 14.1451 15.5818 14.6118 15.3479 14.9537C15.1141 15.2956 14.6474 15.3832 14.3055 15.1493L11.6567 13.3375C11.452 13.1975 11.3297 12.9653 11.3301 12.7173L11.3388 7.26853C11.3395 6.85432 11.6758 6.51907 12.09 6.51973Z"
                fill={props.color ?? resolveColor("--theme-icon-fill-default")}
            />
        </svg>
    );
};
